var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"guide"},[(_vm.loading)?_c('Loader',{attrs:{"stretch":"","absolute":""}}):_c('nb-table-dynamic',{attrs:{"headers":_vm.headers,"items":_vm.guides},on:{"row-click":_vm.openGuide}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }